import React from "react";
import {
  SFGridContainer,
  SFGridItem,
  SFContentContainer,
} from "@sf-core";

const SigninContainer = ({ children }) => (
  <SFContentContainer>
    <SFGridContainer
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{ height: "100vh" }}
    >
      <SFGridItem xs={12} sm={10} md={6} lg={4} xl={3} alignItems="center">
        {children}
      </SFGridItem>
    </SFGridContainer>
  </SFContentContainer>
);

export default SigninContainer;
